/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { AddWhite, EditIcon, SearchIcon, ToggleOffIcon, ToggleOnIcon, TrashIcon } from '../../../assets/icons';
import { Constants, formatAmount, getUpdatedState, Globals } from '../../../utils';
import { Input, Modal, Pagination, Select } from '../../../components';
import { RouteService } from '../../../services';
import ModalCreateRoute from './modal-create-route';

const format = (amount) => {
  return amount > 0 ? formatAmount(amount) : '--';
}

const RouteConfig = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const { data, deleteItem, filters, goToPage, onChange, pagination, reload, search, selects, updateStatus } = useFetchTable();

  const openCreateModal = () => {
    setEditingItem(null);
    setModalKey(k => k + 1);
    setIsModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    setModalKey(k => k + 1);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEditingItem(null);
    setIsModalOpen(false);
  };

  return (
    <main className="p-4 w-full">
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ModalCreateRoute
          key={modalKey}
          initialData={editingItem}
          onClose={closeModal}
          onSuccess={reload}
        />
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="grid grid-cols-[2fr_1fr_1fr_1fr] items-center gap-3">
          <Input
            placeholder="Nombre de ruta"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Select
            placeholder="Estado"
            items={selects.states}
            value={filters.status}
            onValueChange={v => onChange('status', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Rutas</p>

          <button onClick={openCreateModal} className="flex items-center gap-2 bg-orange text-white px-4 py-1.5 rounded-lg font-semibold">
            <img src={AddWhite} className="w-4 h-4" alt="" />
            Agregar
          </button>
        </div>

        <div className="overflow-x-auto px-4">
          <div className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-2 mb-4 text-[11px] [&>div]:text-sm items-end font-bold text-default">
            <div>Código</div>
            <div>Cliente</div>
            <div>Ruta</div>
            <div className="text-right">Facturación por traslado ($)</div>
            <div className="text-right">Deducción (11,20%) ($)</div>
            <div className="text-right">Comisión del conductor ($)</div>
            <div className="text-right">Comisión del propietario ($)</div>
            <div className="text-right">Comisión de la empresa ($)</div>
            <div className="text-center">Activar/ Desactivar</div>
            <div className="text-center">Acción</div>
          </div>

          <div className="space-y-4">
            {data.map((item) => (
              <div 
                key={item.id} 
                className="grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-2 items-center py-2 bg-white border border-gray6 rounded-xl hover:shadow-md transition-shadow text-sm"
              >
                <div className="pl-2">{ String(item.id).padStart(3, '0') }</div>
                <div>{ item?.client?.person?.company?.name || '--' }</div>
                <div>{ item?.name }</div>
                <div className="text-right">{ format(item?.cost) }</div>
                <div className="text-right">{ format(item?.deduction_perc) }</div>
                <div className="text-right">{ format(item?.commission_amount_driver) }</div>
                <div className="text-right">{ format(item?.commission_amount_owner) }</div>
                <div className="text-right">{ format(item?.commission_amount_company) }</div>

                <div className="flex justify-center">
                  {item.status === Constants.ROUTE.STATUS.ACTIVE ? (
                    <img
                      key={`${item.id}-on`}
                      src={ToggleOnIcon}
                      className="w-10 h-10 object-contain cursor-pointer"
                      onClick={() => updateStatus(item.id, Constants.ROUTE.STATUS.INACTIVE)}
                      alt=""
                    />
                  ) : (
                    <img
                      key={`${item.id}-off`}
                      src={ToggleOffIcon}
                      className="w-10 h-10 object-contain cursor-pointer"
                      onClick={() => updateStatus(item.id, Constants.ROUTE.STATUS.ACTIVE)}
                      alt=""
                    />
                  )}
                </div>

                <div className="flex items-center justify-center gap-3">
                  <div className="flex items-center gap-3">
                    <img
                      src={EditIcon}
                      className="w-5 h-5 object-contain cursor-pointer"
                      onClick={() => openEditModal(item)}
                      alt=""
                    />
                    <img
                      src={TrashIcon}
                      className="w-5 h-5 object-contain cursor-pointer"
                      onClick={() => deleteItem(item.id)}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    type: '',
    status: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects, setSelects] = useState({
    states: [],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await RouteService.admin.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);

    } catch (error) {
      setData([]);
      toast.error(String(error));

    } finally {
      setCanFetch(true);
    }
  }

  const getSelects = async () => {
    try {
      setSelects({
        states: [
          { value: '0', label: 'Inactivo' },
          { value: '1', label: 'Activo' },
        ],
      });

    } catch (error) {
      setSelects({ states: [] });
      toast.error(String(error));
    }
  }

  const updateStatus = async (id, status) => {
    const action = status === Constants.ROUTE.STATUS.ACTIVE ? 'activar' : 'desactivar';
    Globals.confirm(`¿Está seguro de que desea ${action} esta ruta?`, async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await RouteService.admin.updateStatus({ id, status });
        toast.success('Ruta actualizada con éxito');
        fetchData();

      } catch (error) {
        toast.error(String(error));
      }
      setCanFetch(true);
    });
  }

  const deleteItem = async (id) => {
    Globals.confirm('¿Está seguro de que desea eliminar esta ruta?', async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await RouteService.admin.destroy(id);
        toast.success('Ruta eliminada con éxito');
        fetchData();

      } catch (error) {
        toast.error(String(error));
      }
      setCanFetch(true);
    });
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
    getSelects();
  }, []);

  return {
    data,
    deleteItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    selects,
    updateStatus,
  }
}

export default RouteConfig;